'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Line = require('./Line');

var _Line2 = _interopRequireDefault(_Line);

var _createShapes = require('./create-shapes');

var _createShapes2 = _interopRequireDefault(_createShapes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getDirection = function getDirection(props) {
  return Object.keys(props).reduce(function (a, b) {
    return a || (props[b] ? b : null);
  }, null);
};

var getShape = function getShape(strokeWidth) {
  return function (_ref) {
    var name = _ref.name;
    var up = _ref.up;
    var down = _ref.down;
    var left = _ref.left;
    var right = _ref.right;

    var shapes = (0, _createShapes2.default)(strokeWidth);
    var direction = getDirection({ up: up, down: down, left: left, right: right }) || 'right';
    if (!shapes[name]) {
      return shapes.x;
    }

    return shapes[name][direction] || shapes[name];
  };
};

var Icon = function Icon(_ref2) {
  var _ref2$name = _ref2.name;
  var name = _ref2$name === undefined ? 'x' : _ref2$name;
  var up = _ref2.up;
  var down = _ref2.down;
  var left = _ref2.left;
  var right = _ref2.right;

  var props = _objectWithoutProperties(_ref2, ['name', 'up', 'down', 'left', 'right']);

  var shape = getShape(props.strokeWidth)({ name: name, up: up, down: down, left: left, right: right });

  return _react2.default.createElement(_Line2.default, _extends({}, props, {
    paths: shape }));
};

exports.default = Icon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reline/dist/Icon.js
 ** module id = 722
 ** module chunks = 0
 **/